import { render, staticRenderFns } from "./timezone-notice.vue?vue&type=template&id=36b7c96d&scoped=true"
import script from "./timezone-notice.vue?vue&type=script&lang=js"
export * from "./timezone-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7c96d",
  null
  
)

export default component.exports